import { render, staticRenderFns } from "./phoneLoginLayout.vue?vue&type=template&id=014676e3"
import script from "./phoneLoginLayout.vue?vue&type=script&lang=js"
export * from "./phoneLoginLayout.vue?vue&type=script&lang=js"
import style0 from "./phoneLoginLayout.vue?vue&type=style&index=0&id=014676e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports